/**
 * Picks v2 or v1 of the Challenges page based on the redesign flag.
 * Same pattern as the other page switches in this codebase.
 */
import React from 'react';
import { useRedesignFlag } from '../../../utils/redesignFlag';
import ChallengePage   from './ChallengePage';
import ChallengePageV2 from './ChallengePageV2';

export default function ChallengePageSwitch(props) {
  const [v2] = useRedesignFlag();
  const Component = v2 ? ChallengePageV2 : ChallengePage;
  return <Component {...props} />;
}
